export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10157.f5b99313.jpg";